import { Routes } from '@angular/router';

export const routing: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./home/home.page').then(m => m.HomePage),
  },
  {
    path: 'questions-flow',
    loadComponent: () => import('./questions-flow/questions-flow.page').then(m => m.QuestionsFlowPage),
  },
  {
    path: 'terms-of-use',
    loadComponent: () => import('./terms-of-use/terms-of-use.page').then(m => m.TermsOfUsePage),
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },

];
